import type { EmersonFeaturedProduct } from "@emerson/scenes/HomePage/FeaturedProducts/FeaturedProducts";

const MockFeaturedProducts: EmersonFeaturedProduct[] = [
  {
    __typename: "Product",
    id: "U3ByZWU6OlByb2R1Y3QtMTAwNTg4",
    name: "Seed DS-01® Daily Synbiotic",
    brandName: "Seed",
    slug: "ds-01-daily-synbiotic",
    image: "https://assets.fullscript.io/Product/SED001/1000_front.png",
    availableOrMasterVariant: {
      id: "1",
      __typename: "Variant",
      emersonVariantId: "SYNFS",
    },
  },
  {
    __typename: "Product",
    id: "U3ByZWU6OlByb2R1Y3QtMTA0MTc2",
    name: "Quercetin Phospholipid 250mg",
    brandName: "Protocol for Life Balance",
    slug: "quercetin-phytosome-250mg",
    image: "https://static.emersonecologics.com/a0fe9400-86b9-487b-bdc5-890131fb5c5e-358-358.png",
    availableOrMasterVariant: {
      id: "2",
      __typename: "Variant",
      emersonVariantId: "P3087",
    },
  },
  {
    __typename: "Product",
    id: "U3ByZWU6OlByb2R1Y3QtOTczMzM=",
    name: "Silver Bio-Active Hydrosol Nasal",
    brandName: "Argentyn 23",
    slug: "silver-bio-active-hydrosol-nasal",
    image: "https://assets.fullscript.io/Product/AR0013/1000_front.png",
    availableOrMasterVariant: {
      id: "3",
      __typename: "Variant",
      emersonVariantId: "34CS23",
    },
  },
];

export { MockFeaturedProducts };
